import styled from 'styled-components';

export const Container = styled.div`
  .ancho {
    width: 600px;
    //ocultar scroll
    overflow: hidden;
  }
`;
